import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Campaign from '../entities/campaign'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';

interface CampaignState extends ListState<Campaign> {
    editCampaign: Campaign;
    permissions: Array<string>
}

class CampaignModule extends ListModule<CampaignState, any, Campaign> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Campaign>(),
        loading: false,
        editCampaign: new Campaign(),
        permissions: new Array<string>()
    }
    actions = {
        async getAll(context: ActionContext<CampaignState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.get('/api/services/app/Campaign/GetAll', {params: payload.data});
            context.state.loading = false;
            let page = response.data.result as PageResult<Campaign>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<CampaignState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/services/app/Campaign/Create', payload.data);
            context.state.loading = false;
        },
        async update(context: ActionContext<CampaignState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.put('/api/services/app/Campaign/Update', payload.data);
            context.state.loading = false;
        },
        async delete(context: ActionContext<CampaignState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.delete('/api/services/app/Campaign/Delete?Id=' + payload.data.id);
            context.state.loading = false;
        },
        async get(context: ActionContext<CampaignState, any>, payload: any) {
            let response = await Ajax.get('/api/services/app/Campaign/Get?Id=' + payload.id);
            return response.data.result as Campaign;
        },
        async getAllPermissions(context: ActionContext<CampaignState, any>) {
            let response = await Ajax.get('/api/services/app/Campaign/getAllPermissions');
            context.state.permissions = response.data.result.items;
        }
    };
    mutations = {
        setCurrentPage(state: CampaignState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: CampaignState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: CampaignState, campaign: Campaign) {
            state.editCampaign = campaign;
        }
    }
}

const campaignModule = new CampaignModule();
export default campaignModule;